import { Component, OnInit } from "@angular/core";
import { WaitingModalService, NotificationService, ArianeStore, TokenDto, CerbaAuthService, IAuthenticationPublicWebServiceClient, UserStore } from "@digicerba/common";
import { SaveInstanceModeleFormulaireDto, IInstanceModeleFormulaireWebServiceClient, InstanceModeleFormulaireDto } from "@common/resources/resources";
import { Router, ActivatedRoute } from "@angular/router";
import { AsiFileService } from "@asi-ngtools/lib";
import { environment } from "@environments/*";
import { find } from 'lodash';
import { PDFService } from '../../../../common/services/pdf.service';

@Component({
    selector: 'guest-instance',
    templateUrl: './instance-guest.component.html',
})
export class GuestInstanceComponent implements OnInit {

    token: TokenDto

    pending: boolean;
    printElement: HTMLElement;
    cacheWidth: number;
    htmlContent = 'Chargement ...';
    formulaire: SaveInstanceModeleFormulaireDto = new SaveInstanceModeleFormulaireDto();

    constructor(private notificationService: NotificationService, private router: Router, private fileUtils: AsiFileService,
        private activatedRoute: ActivatedRoute,
        private pageTokenWebService: IAuthenticationPublicWebServiceClient,
        private instanceModeleFormulaireWebServiceClient: IInstanceModeleFormulaireWebServiceClient,
        private cerbaAuthService: CerbaAuthService,
        private waitingModal: WaitingModalService,
        private pdfService: PDFService)
    {

    }

    ngOnInit() {

        let pageToken = this.activatedRoute.snapshot.queryParams["page_token"];
        this.pageTokenWebService.validateToken({ token: pageToken }).subscribe((res: TokenDto) => {
            this.token = res;
            this.cerbaAuthService.setTokenAuthenticationHeader(this.token.cookie);
            if (res.maxUse > -1 && res.count > res.maxUse) {
                this.router.navigate(['']);
            }

            this.initFormulaire();
            this.fileUtils.getFileAsText(environment.contextPath + 'api/document/' + this.formulaire.instance.idModeleFormulaire).subscribe((file) => {
                this.htmlContent = file;
            });
        }, () => {
            this.router.navigate(['']);
        });

    }

    initFormulaire(): void {
        this.formulaire.instance = new InstanceModeleFormulaireDto();
        this.formulaire.valeurs = [];
        this.formulaire.instance.idUser = -1;
        this.formulaire.instance.idModeleFormulaire = this.activatedRoute.snapshot.params['id'];
    }

    fillForm(): void {
        const printElement = document.getElementById('print-section');
        const elements = printElement.getElementsByTagName('*');
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            if (element instanceof HTMLInputElement) {
                const input: HTMLInputElement = element;
                if (input.id.startsWith('formulairedemat_')) {
                    let valeurInstance = this.formulaire.valeurs.find(elt => {
                        return elt.cle === input.id.replace('formulairedemat_', '');
                    });
                    if (valeurInstance != null) {
                        input.type === 'checkbox' ? input.checked = valeurInstance.valeur == 'true' : input.value = valeurInstance.valeur;
                    }
                }
            }
        }
    }

    save(): void {
        this.waitingModal.openModal();
        // création d'une instance
        const printElement = document.getElementById('print-section');
        const elements = printElement.getElementsByTagName('*');
        this.pending = true;
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            if (element instanceof HTMLInputElement) {
                const input: HTMLInputElement = element;
                if (input.id.startsWith('formulairedemat_')) {
                    let id = input.id.replace('formulairedemat_', '');
                    let valeur = find(this.formulaire.valeurs, function (v) {
                        return v.cle === id;
                    });

                    if (valeur) {
                        valeur.valeur = (input.type === 'checkbox' ? input.checked + "" : input.value);
                        valeur.idInstanceModele = this.formulaire.instance.id;
                    } else {
                        this.formulaire.valeurs.push({
                            cle: id,
                            valeur: (input.type === 'checkbox' ? input.checked + "" : input.value),
                            idInstanceModele: this.formulaire.instance.id
                        });
                    }
                }
            }
        }
        this.formulaire.instance.status = 'TERMINE';

        this.instanceModeleFormulaireWebServiceClient.saveInstanceModeleFormulaire(this.formulaire).subscribe(() => {
            this.router.navigate(['logout']);
        },
            () => {
                this.notificationService.showErrorNotification("ERRORS.unprocessable");
            });
        this.waitingModal.closeModal();
    }

    checkIFrame() {
        try {
          return window.self !== window.top;
        } catch (e) {
          return true;
        }
      }

    /*************************************************************************************
     *************************************IMPRESSION**************************************
     *************************************************************************************/

    async print() {

        this.pending = true;

        const printElement = document.getElementById('formulairedemat');
        let orientation = 'portrait';
        let multipage = false;

        for (let i = 0; i < printElement.attributes.length; i++) {
          const attribute = printElement.attributes.item(i);
          if (attribute.name === 'orientation') {
            orientation = attribute.value;
          } else if (attribute.name === "multipage") {
            multipage = true;
          }
        }

        const margin = 20;
        const pdf = this.pdfService.createPDF(orientation, 'pt', 'a4');
        const pdfWidth = this.pdfService.getPDFWidth(pdf, margin);

        this.waitingModal.openModal();

        await this.pdfService.printDiv(pdf, printElement as HTMLElement, margin, pdfWidth, multipage);

        this.waitingModal.closeModal();
        this.pdfService.save(pdf, 'HTML-Document.pdf');
        this.pending = false;
      }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/guest/instance-guest.component.ts